import axios from "../../axios-auth";
import { pathOr } from "ramda";
import {
  i18n,
  PREFIX,
  addDefaultTranslations,
  setLanguageAttributes
} from "../../i18n.js";
import { v4 as uuidv4 } from "uuid";

import constants from "../../helpers/constants";
import qs from "qs";

var hash = require("object-hash");

const productPartsOptionCode = "product_parts";
const productPartsOptionLabel = i18n.t("Product Parts");

const state = {
  data: {},
  webProductId: 0,
  webProductSku: "",
  selectionId: 0,
  activeProductPartCode: "",
  activePageOptions: {},
  isLoading: false,
  numberOfUploads: 0,
  networkError: false,
  networkMessage: "",
  filesNeedToBeConnected: true,
  filesConnectLoading: false,
  numberOfActiveUploads: 0,
  selector: "",
  selectedTemplateId: null,
  theme: "",
  config: null,
  storeCode: null,
  isMobile: false,
  vueInstance: null
};

const getters = {
  getHideQuotationButton: state => {
    return state.data.config.hide_quotation
      ? parseInt(state.data.config.hide_quotation)
      : 1;
  },
  getCimpressProductId: state => {
    return state.data.cimpress_product_id;
  },
  getProductPartModeShow: state => {
    const default_display = "poptext";
    if (state.data.config.hasOwnProperty("product_part_display_type")) {
      if (
        ["poptext", "tabs"].includes(
          state.data.config.product_part_display_type
        )
      ) {
        return state.data.config.product_part_display_type;
      }
    }
    return default_display;
  },
  getWebproductHashData: (state, getters) => {
    return hash({
      webproductId: getters.getWebProductId,
      name: state.data.name,
      type: state.data.type,
      store_code: getters.getStoreCode
    });
  },
  getSweetAlert: (state, getters) => {
    return getters.getVueInstance.$swal;
  },
  getVueInstance: state => {
    return state.vueInstance;
  },
  getIsMobile: state => {
    return state.isMobile;
  },
  getIntegrationIdConfig: state => {
    if (state.config && state.config.integrationId) {
      return state.config.integrationId;
    }
    return null;
  },
  getStoreCode: state => {
    if (state.storeCode) {
      return state.storeCode;
    }
    if (state.config && state.config.storeCode) {
      return state.config.storeCode;
    }
    return null;
  },
  getIsStoreCodeStiegl: state => {
    const storeCode = pathOr(null, ["storeCode"], state);
    if (storeCode === "Stiegl_de") {
      return true;
    }
    return false;
  },
  getMatrixConfiguration: state => {
    if (state.data.themeMatrix) {
      var themeCss = Object.keys(state.data.themeMatrix).map(el => {
        return el + ":" + state.data.themeMatrix[el];
      });

      var fontStyle = "";
      if (state.data.themeMatrixFonts) {
        for (var font of state.data.themeMatrixFonts) {
          fontStyle += " " + font;
        }
      }

      if (themeCss.length) {
        if (!state.data.themeMatrix["--pq_mainColor"]) {
          themeCss.push("--pq_mainColor : #3141a7");
        }
        return (
          "<style>:root{" + themeCss.join(";") + "} " + fontStyle + "</style>"
        );
      }
    } else if (state.config && state.config.theme) {
      // we do want to load themes,
      // but the data is not present yet
      return "<style>:root{--pq_mainColor:transparent}</style>";
    }
    return null;
  },
  getInstanceConfig: state => {
    return state.config;
  },
  getIsUploadWithoutConfiguration: state => {
    return state.data.product_type == "upload_without_configuration";
  },
  getWebProductSku: state => {
    return state.webProductSku;
  },
  getShowAddToCart: state => {
    return state.data.config.isLoggedIn
      ? parseInt(state.data.config.isLoggedIn)
      : 1;
  },
  getTheme: state => {
    return state.theme;
  },
  getPackingUnit: state => {
    return state.data.config.pck_unit &&
      parseInt(state.data.config.pck_unit) > 0
      ? parseInt(state.data.config.pck_unit)
      : 1;
  },
  getHideSearchBoxInPoptext: state => {
    return state.data.config.hide_searchbox_poptext
      ? parseInt(state.data.config.hide_searchbox_poptext)
      : 0;
  },
  getPersonalizationQuantityWithPrice: (state, getters) => {
    if (
      state.data.product_type == "personalization" &&
      state.data.config.quantity_show_price_personalization &&
      getters.getQuantitySelection &&
      getters.getQuantitySelection != ""
    ) {
      return true;
    }
    return false;
  },
  getMeasurementSystem: state => {
    return state.data.config.measuring_system
      ? state.data.config.measuring_system
      : "";
  },
  getShowCostCenter: state => {
    return state.data.config.enable_cost_center
      ? parseInt(state.data.config.enable_cost_center)
      : 0;
  },
  getCostCenterIsRequired: (state, getters) => {
    return getters.getShowCostCenter &&
      state.data.config.enable_cost_center_required
      ? parseInt(state.data.config.enable_cost_center_required)
      : 0;
  },
  getOtherOptionsDenyRules: (state, getters) => {
    var denyRules = Array.isArray(getters.getDenyRules["prod_opts"])
      ? null
      : getters.getDenyRules["prod_opts"];

    return denyRules;
  },
  getPackingTdTextures: state => {
    return state.data.template_config && state.data.template_config.td_data
      ? state.data.template_config.td_data
      : null;
  },

  getSelectedTemplateId: (state, getters) => {
    var activeTemplates = getters.getActiveTemplates;
    return state.selectedTemplateId == null
      ? Object.keys(activeTemplates)[0]
      : state.selectedTemplateId;
  },
  getWebProductEnableTemplateChooser: (state, getters) => {
    var activeTemplates = getters.getActiveTemplates;
    if (
      Object.keys(activeTemplates).length > 1 &&
      state.data.template_chooser &&
      parseInt(state.data.template_chooser) == 0
    ) {
      return true;
    }
    return false;
  },
  getWebProductEnableTemplates: (state, getters) => {
    var templates = [];
    var activeTemplates = getters.getActiveTemplates;
    for (var id in activeTemplates) {
      templates.push({
        id,
        text: activeTemplates[id]
      });
    }

    return templates;
  },
  getWebProductTemplate: (state, getters) => {
    var activeTemplates = getters.getActiveTemplates;
    if (
      (state.data.template_chooser &&
        parseInt(state.data.template_chooser) == 1) ||
      getters.getIsStockDefaultPDf
    ) {
      return Object.keys(activeTemplates);
    }
    if (
      typeof activeTemplates === "object" &&
      Object.keys(activeTemplates).length > 0
    ) {
      return getters.getSelectedTemplateId;
    }
    return pathOr(0, ["data", "template"], state);
  },
  getActiveTemplates: (state, getters) => {
    var changeOptionsTemplate = getters.getChangeOptionsTemplate;
    if (changeOptionsTemplate) {
      return changeOptionsTemplate;
    }
    return pathOr({}, ["data", "template"], state);
  },
  getQuantitySelection: state => {
    return state.data.config.quantity_selection;
  },
  getSelector: state => {
    return state.selector;
  },
  getNumberOfActiveUploads: state => {
    return state.numberOfActiveUploads;
  },
  getFilesConnectLoading: state => {
    return state.filesConnectLoading;
  },
  getConnectFolder: state => {
    return state.selectionId;
  },
  getFilesNeedToBeConnected: state => {
    return state.filesNeedToBeConnected;
  },
  getIsPrintingProduct: state => {
    return state.data.config.printing_product;
  },
  getIsCimpressProduct: state => {
    return state.data.is_cimpress_product;
  },
  getIsImageEditorProduct: state => {
    return state.data.config.enable_image_editor | 0;
  },
  getIsStockDefaultPDfConfig: state => {
    return state.data.product_type === "stock_configuration_default_pdf";
  },
  getIsStockDefaultPDf: state => {
    return (
      state.data.product_type === "stock_configuration_default_pdf" ||
      state.data.product_type === "stock_default_pdf"
    );
  },
  getNetworkError: state => {
    return state.networkError;
  },
  getNetworkMessage: state => {
    return state.networkMessage;
  },
  getHasAutomaticConnect: state => {
    if (!state.data.config.hasOwnProperty("enable_automatic_connect")) {
      return constants.AUTOMATIC_CONNECT_NOT_PRESENT;
    }
    return state.data.config.enable_automatic_connect &&
      parseInt(state.data.config.enable_automatic_connect)
      ? constants.AUTOMATIC_CONNECT_TRUE
      : constants.AUTOMATIC_CONNECT_FALSE;
  },
  getNumberOfPP: state => {
    return state.data.productparts.length;
  },
  getIsLfp: state => {
    return state.data.product_type === "image_editor";
  },
  getNumberOfUploads: state => {
    return state.numberOfUploads;
  },
  getLayoutType: state => {
    return state.data.type;
  },
  getConfig: state => {
    return state.data.config;
  },

  getProductName: state => {
    return state.data.name;
  },
  getWebProductData: state => {
    return state.data;
  },

  getActiveProductPartCode: state => {
    return state.activeProductPartCode;
  },
  getWebProductId: state => {
    return state.webProductId;
  },
  getActivePageOptions: state => {
    return state.activePageOptions[state.activeProductPartCode];
  },
  getWebProductName: state => {
    return state.data.name;
  },
  getActiveProductPart: state => {
    if (!state.data.productparts) {
      return [];
    }
    return state.data.productparts.filter(item => {
      return item.code == state.activeProductPartCode;
    });
  },
  getActiveProductPartName: (state, getters) => {
    var activeProductPart = getters.getActiveProductPart;
    return activeProductPart.length > 0 ? activeProductPart[0].label : "";
  },
  getActiveProductPageOptions: (state, getters) => {
    return getters.getAllProductPageOptions(false);
  },
  getAllProductPageOptions: (state, getters, rootState, rootGetters) => all => {
    var allOptions = all ? true : false;
    var activeProductPart = getters.getActiveProductPart;
    var allPageOptions =
      activeProductPart.length > 0 ? activeProductPart[0].page_options : {};
    var options = Object.keys(allPageOptions)
      .filter(item => {
        return allOptions || allPageOptions[item].hidden == 0;
      })
      .reduce((obj, key) => {
        obj[key] = allPageOptions[key];
        return obj;
      }, {});

    /*if (
      !rootGetters.getChangeOptionsDataPPOpt[
        "PP_" + getters.getActiveProductPartCode
      ]
    ) {
      return {};
    }*/
    var selectedOpt =
      rootGetters.getChangeOptionsDataPPOpt[
        "PP_" + getters.getActiveProductPartCode
      ];
    var denyRules = Array.isArray(rootGetters.getDenyRules)
      ? null
      : rootGetters.getDenyRules[state.activeProductPartCode];

    if (typeof rootGetters.getDenyRules["global_rule"] !== "undefined")
      denyRules = Object.assign(
        {},
        denyRules,
        rootGetters.getDenyRules["global_rule"]
      );

    var items = {};
    for (var op in options) {
      var item = JSON.parse(JSON.stringify(options[op]));
      if (getters.getIsCimpressProduct) {
        if (getters.getIsCimpressPreferredSelection && item.isRange) {
          continue;
        }
        const remainingOptions = getters.getCimpressRemainingOptions({
          pp: getters.getActiveProductPartCode,
          po: op
        });
        if (remainingOptions) {
          if (item.isRange) {
            if (remainingOptions.isRange) {
              item.ranges = remainingOptions.ranges;
            } else {
              item.ranges = remainingOptions.values.map(el => {
                return { minimum: el, maximum: el };
              });
            }
          } else {
            item.values = JSON.parse(
              JSON.stringify(
                options[op].values.map(el => {
                  if (!remainingOptions.values.includes(el.value)) {
                    return { ...el, disabled: true };
                  }
                  return el;
                })
              )
            );
          }
        }
      }
      item.label = i18n.t(PREFIX.PO + options[op].label);
      item.tooltip = options[op].tooltip;

      if (denyRules && denyRules[op]) {
        item.values = JSON.parse(
          JSON.stringify(
            options[op]["values"].filter(el => {
              return !denyRules[op].includes(el.value);
            })
          )
        );
      }

      for (var value in item.values) {
        item.values[value].label = i18n.t(
          PREFIX.POV + item.values[value].label
        );

        if (
          options[op].preferred_value &&
          item.values[value].value == options[op].preferred_value
        ) {
          item.values[value].preferred_value = true;
        }
      }

      item["selected"] = selectedOpt[op];
      items[op] = item;
    }
    return items;
  },
  getShowOptionsTable: (state, getters) => {
    var partOptions = state.data.productparts;
    var show = false;
    for (var part of partOptions) {
      if (part.page_options) {
        var visibleProductParts = Object.keys(part.page_options).filter(
          item => {
            return (
              part.page_options[item].code !== "ProductionSpeed" &&
              getters.getCimpressNoQuantity &&
              !part.page_options[item].hidden
            );
          }
        );
        if (visibleProductParts.length > 0) {
          show = true;
          break;
        }
      }
    }
    return show;
  },
  getIsLoading: state => {
    return state.isLoading;
  },
  getSelectionId: state => {
    return state.selectionId;
  },
  getProductPartsNames: state => {
    return state.data.productparts.map(item => {
      return { code: item.code, label: item.label };
    });
  },
  getProductPartsCodes: state => {
    return state.data.productparts.map(item => {
      return item.code;
    });
  },
  getPOFromProductPartByCode: state => code => {
    var pp = state.data.productparts.filter(item => {
      return item.code == code;
    });
    return pp.length ? pp[0].page_options : [];
  },
  getActiveProductOptionsSelection: (
    state,
    getters,
    rootState,
    rootGetters
  ) => {
    //if (state.isLoading) return [];
    var activeProductPart = getters.getActiveProductPart;
    var ppParts = rootGetters.getChangeOptionsDataPPOpt;
    var ppSelection = ppParts["PP_" + activeProductPart[0].code];

    var activePageOption = getters.getActivePageOptions;
    if (!ppSelection[activePageOption]) {
      return [];
    }
    return ppSelection[activePageOption];
  },
  getInitialChangeOptionsPostData: (state, getters, rootState, rootGetters) => {
    var qties = rootGetters.getCustomQuantitiesLabels;

    let postData = {
      webproduct: getters.getWebProductId,
      custom_quantities: qties.length == 0 ? "" : qties
    };
    if (getters.getStoreCode) {
      postData["store_code"] = getters.getStoreCode;
    }
    if (getters.getAppSelectionId) {
      postData["selection"] = getters.getSelectionId;
    }
    var data = getters.getWebProductData;
    for (let option in data.options) {
      if (option == "quantity") {
        // set the qty field also
        var default_value = data.options[option].default_value;
        var qty = 1;
        for (var value of data.options[option].values) {
          if (value.value == default_value) {
            qty = value.attributes["qty"];
            break;
          }
        }
        postData["qty"] = qty;
      }
      postData[
        "print_options[" + option + "][" + option + "][]"
      ] = Array.isArray(data.options[option].default_value)
        ? data.options[option].default_value[0]
        : data.options[option].default_value;
    }
    postData["print_options[PP][]"] = getters.getActiveProductPartCode;
    if (getters.getIsCimpressProduct) {
      postData.is_cimpress_product = true;
      postData.cimpress_product_id = data.cimpress_product_id;
    }

    for (let ppKey in data.productparts) {
      var pp = data.productparts[ppKey];
      for (let attribute in pp.page_options) {
        postData[
          "print_options[PP_" + pp.code + "][" + attribute + "][]"
        ] = Array.isArray(pp.page_options[attribute].default_value)
          ? pp.page_options[attribute].default_value[0]
          : pp.page_options[attribute].default_value;
      }
    }

    if (getters.getPersonalizationQuantityWithPrice) {
      var qties = getters.getQuantitySelection.split(",");
      var updatedQty = [];
      for (let qty in qties) {
        updatedQty.push("custom_qty_" + qties[qty]);
      }
      for (let qty in qties) {
        postData["custom_quantities"] = updatedQty;
      }
    }
    return postData;
  },
  getOtherOptions: (state, getters, rootState, rootGetters) => {
    var options = state.data.options;
    var data = [];
    var deniedValues = getters.getOtherOptionsDenyRules;
    for (var option in options) {
      if (options[option].hidden || option == "quantity") {
        continue;
      }
      var allValues = options[option].values;
      if (deniedValues && deniedValues[option]) {
        allValues = options[option].values.filter(el => {
          return !deniedValues[option].includes(el.value);
        });
      }

      var item = {
        type: options[option].type,
        code: option,
        tooltip: options[option].tooltip,
        name: i18n.t(PREFIX.PO + options[option].label),
        values: allValues.map(el => {
          return {
            text: i18n.t(PREFIX.POV + el.label),
            id: el.value,
            tooltip: el.tooltip
          };
        }),
        selected: rootGetters.getChangeOptionsDataPPOpt[option][option] // ????
      };
      data.push(item);
    }
    return data;
  },
  getProductPartsOption: (state, getters) => {
    return {
      multiselect: 0,
      code: productPartsOptionCode,
      name: productPartsOptionLabel,
      values: state.data.productparts.map(el => {
        return {
          text: i18n.t(PREFIX.PP + el.label),
          id: el.code
        };
      }),
      selected: [getters.getActiveProductPartCode]
    };
  },
  getOptions: (state, getters) => {
    var activePPOptions = getters.getActiveProductPageOptions;
    var data = [];
    var item = {};
    // add the product parts if we have more than one
    if (state.data.productparts.length > 1) {
      item = getters.getProductPartsOption;
      data.push(item);
    }

    for (var option in activePPOptions) {
      if (activePPOptions[option].hidden) {
        continue;
      }

      if (option == "ProductionSpeed" && getters.getCimpressNoQuantity) {
        continue;
      }

      item = {
        multiselect: 0,
        code: option,
        //name: i18n.t(PREFIX.PO + activePPOptions[option].label),
        name: activePPOptions[option].label,
        values: activePPOptions[option].values
          ? activePPOptions[option].values.map(el => {
              const item = {
                //text: i18n.t(PREFIX.POV + el.label),
                text: el.label,
                id: el.value,
                tooltip: el.tooltip
              };
              if (el.disabled) {
                item["disabled"] = true;
              }
              return item;
            })
          : [],
        ranges: activePPOptions[option].ranges
          ? activePPOptions[option].ranges
          : [],
        tooltip: activePPOptions[option].tooltip,
        selected: activePPOptions[option].selected,
        preferred_value: activePPOptions[option].preferred_value
      };

      if (option == "format" && getters.getConfig.enable_custom_format) {
        //add custom formats
        if (getters.getConfig.enable_packaging) {
          for (var pack in getters.getPackingCustomFormats) {
            item.values.push({
              text: getters.getPackingCustomFormats[pack].label,
              id: getters.getPackingCustomFormats[pack].value
            });
          }
        } else {
          for (var cust of getters.getCustomFormats) {
            item.values.push({
              text: cust.label,
              id: cust.value
            });
          }
        }
      }

      data.push(item);
    }
    return data;
  },
  getProductPartsOptionCode: state => {
    return productPartsOptionCode;
  },
  getShowPreviewInUpload: state => {
    return state.data.config.hasOwnProperty("upload_previews")
      ? parseInt(state.data.config.upload_previews)
      : 1;
  },
  getShouldRenderComponent: state => name => {
    if (
      parseInt(state.data.config.disable_upload) &&
      ["Upload", "UploadButton", "UploadContainer", "UploadTable"].includes(
        name
      )
    ) {
      return false;
    }
    if (
      !parseInt(state.data.config.enable_custom_quantity) &&
      ["InputQuantity"].includes(name)
    ) {
      return false;
    }
    if (
      !parseInt(state.data.config.personalize) &&
      ["PersonalizationButton"].includes(name)
    ) {
      return false;
    }
    if (
      !parseInt(state.data.config.enable_custom_format) &&
      ["InputCustomFormatInsert", "InputCustomFormat"].includes(name)
    ) {
      return false;
    }
    if (
      !parseInt(state.data.config.show_matrix) &&
      [
        "ProductPartsNamesContainer",
        "ProductPartsNames",
        "ProductParts"
      ].includes(name)
    ) {
      return false;
    }

    if (["PackingOptions", "PackingOptionsContainer"].includes(name)) {
      if (
        parseInt(state.data.config.enable_custom_format) &&
        parseInt(state.data.config.enable_packaging)
      ) {
        return true;
      }
      return false;
    }

    return true;
  },
  getPackagingVariables: state => {
    return pathOr([], ["data", "packing_config", "packaging_variables"], state);
  },
  getPackagingModel: state => {
    return pathOr("", ["data", "packing_config", "model"], state);
  },
  getInputUnit: state => {
    return pathOr("mm", ["data", "packing_config", "Input_Unit"], state);
  },
  getIsPackingEnabled: (state, getters) => {
    if (getters.getConfig.enable_packaging) {
      return parseInt(getters.getConfig.enable_packaging) ? true : false;
    }
    return false;
  },
  getEnableLoader: (state, getters) => {
    return getters.getConfig.enable_loader;
  },
  getIsPreflighPitstop: (state, getters) => {
    return (
      getters.getConfig.preflight_enabled &&
      getters.getConfig.preflight_type == "pitstop"
    );
  },
  getIsPersonalizationNewPage: state => {
    return pathOr(1, ["data", "config", "isPersonalizationNewPage"], state);
  },
  getShowConnectButton: (state, getters) => {
    if (getters.getHasAutomaticConnect == constants.AUTOMATIC_CONNECT_FALSE) {
      if (
        getters.getFilesNeedToBeConnected &&
        !getters.getConfig.disable_upload &&
        !getters.getConfig.personalize &&
        getters.getNumberOfPP == getters.getNumberOfUploads
      ) {
        return true;
      }
    }
    return false;
  },
  getPriceDisplayType: state => {
    const displayType = parseInt(
      pathOr(
        constants.TAX_DISPLAY_TYPE_EXCL_TAX,
        ["data", "config", "price_display_type"],
        state
      )
    );
    if (
      ![
        constants.TAX_DISPLAY_TYPE_EXCL_TAX,
        constants.TAX_DISPLAY_TYPE_INCL_TAX,
        constants.TAX_DISPLAY_TYPE_BOTH
      ].includes(displayType)
    ) {
      return constants.TAX_DISPLAY_TYPE_EXCL_TAX;
    }
    return displayType;
  },
  getIsValidForm: (state, getters) => widget => {
    var valid = true;
    var isPrintingProduct = getters.getIsPrintingProduct;
    var isImageEditorProduct = getters.getIsImageEditorProduct;
    var hasAutomaticConnect = getters.getHasAutomaticConnect;
    var isStockDefaultPDfConfig = getters.getIsStockDefaultPDfConfig;
    var noPP = getters.getNumberOfPP;
    var noUploads = getters.getNumberOfUploads;
    var isLfp = getters.getIsImageEditorProduct;

    if (isPrintingProduct || noPP > 0) {
      if (isPrintingProduct && !isLfp) {
        if (
          hasAutomaticConnect == constants.AUTOMATIC_CONNECT_NOT_PRESENT ||
          hasAutomaticConnect == constants.AUTOMATIC_CONNECT_TRUE
        ) {
          if (
            hasAutomaticConnect == constants.AUTOMATIC_CONNECT_TRUE &&
            getters.getMatrixOneSelection == false
          ) {
            // check that the user made at least one selection in matrix
            if (widget) {
              widget.$swal({
                text: i18n.t("Please configure your product !"),
                icon: "warning"
              });
            }
            return false;
          }
          if (
            noPP !== noUploads &&
            !isImageEditorProduct &&
            !isStockDefaultPDfConfig
          ) {
            valid = false;
            if (widget) {
              widget.$swal({
                text: i18n.t("Please make an upload for each product part!"),
                icon: "warning"
              });
            }
            return false;
          }
        }
      }
    }

    return valid;
  },

  getCallChangeOptionPerType: (state, getters) => {
    if (
      [
        "image_editor",
        "upload_configuration",
        "personalization_configuration",
        "stock_configuration_default_pdf",
        "upload_without_configuration",
        "upload_personalization_configuration",
        "upload_fullpage_configuration",
        "personalization_fullpage_configuration",
        "upload_personalization_configuration_packaging",
        "upload_personalization_fullpage_configuration"
      ].includes(state.data.product_type)
    ) {
      return true;
    }
    if (getters.getPersonalizationQuantityWithPrice) {
      return true;
    }
    return false;
    /*if (
      state.data.config.call_change_options == undefined ||
      state.data.config.call_change_options == null
    ) {
      return false;
    }

    return state.data.config.call_change_options;*/
  }
};

const mutations = {
  setVueInstance: (state, payload) => {
    state.vueInstance = payload;
  },
  setIsMobile: (state, payload) => {
    state.isMobile = payload;
  },
  setStoreCode: (state, payload) => {
    state.storeCode = payload;
  },
  setTheme: (state, payload) => {
    state.theme = payload;
  },
  setSelector: (state, payload) => {
    state.selector = payload;
  },
  setFilesConnectLoading: (state, payload) => {
    state.filesConnectLoading = payload;
  },
  setFilesNeedToBeConnected: (state, payload) => {
    state.filesNeedToBeConnected = payload;
  },
  setNetworkError: (state, payload) => {
    if (payload == null) {
      state.networkError = false;
      state.networkMessage = "";
    } else {
      state.networkError = true;
      state.networkMessage =
        i18n.t("Error connecting to server") +
        " : " +
        (payload.message ? payload.message : i18n.t("Network Error"));
    }
  },
  setWebProductData: (state, payload) => {
    state.data = { ...state.data, ...payload };
    state.activeProductPartCode = payload.productparts[0].code;
    var activePageOptions = {};
    for (var key in payload.productparts) {
      var obj = payload.productparts[key];
      var visibleProductParts = Object.keys(obj.page_options).filter(item => {
        return obj.page_options[item].hidden == 0;
      });

      activePageOptions[obj.code] = visibleProductParts[0];
    }
    state.activePageOptions = activePageOptions;
  },
  setActiveProductPageOption: (state, payload) => {
    var activePageOptions = { ...state.activePageOptions };
    activePageOptions[state.activeProductPartCode] = payload;
    state.activePageOptions = activePageOptions;
  },
  setActiveProductPartName: (state, payload) => {
    state.activeProductPartCode = payload;
  },
  setIsLoading: (state, payload) => {
    state.isLoading = payload;
  },
  setWebProductId: (state, payload) => {
    state.webProductId = payload;
  },
  setWebProductSku: (state, payload) => {
    state.webProductSku = payload;
  },
  setSelectionId: (state, payload) => {
    state.selectionId = payload;
  },
  uploadFile: state => {
    state.numberOfUploads++;
  },
  removeUploadedFile: state => {
    state.numberOfUploads--;
  },
  uploadLoading: (state, payload) => {
    if (payload) {
      state.numberOfActiveUploads++;
    } else {
      state.numberOfActiveUploads--;
    }
  },
  setSelectedTemplateId: (state, payload) => {
    state.selectedTemplateId = payload;
  },
  setInstanceConfig: (state, payload) => {
    state.config = payload;
  }
};

const actions = {
  connectUploads: ({ commit, getters }, payload) => {
    commit("setPersonalizeLoading", true);

    axios.instance
      .post(
        getters.getUrl(axios.connectUpload),
        qs.stringify({
          selection: getters.getConnectFolder,
          store_code: getters.getStoreCode
        })
      )
      .then(response => {
        if (response.data.success) {
          // files connected
          commit("setFilesNeedToBeConnected", false);
          commit("setDisableDeleteUploadAfterConnect", true);
        } else if (response.data.message) {
          // files connected
          payload.widget.$swal({
            text: "Error " + response.data.message,
            icon: "error"
          });
        }
        commit("setPersonalizeLoading", false);
      })
      .catch(error => {
        commit("setPersonalizeLoading", false);
        console.log("Error " + error);
        payload.widget.$swal({
          text: "Error " + error,
          icon: "error"
        });
      });
  },
  setIsMobile: ({ commit }, payload) => {
    commit("setIsMobile", payload);
  },
  setFilesNeedToBeConnected: ({ commit }, payload) => {
    commit("setFilesNeedToBeConnected", payload);
  },
  setNetworkError: ({ commit }, payload) => {
    commit("setNetworkError", payload);
  },
  setWebProductData: ({ commit }, payload) => {
    commit("setWebProductData", payload);
  },
  setActiveProductPageOption: ({ commit }, payload) => {
    commit("setActiveProductPageOption", payload);
  },
  setActiveProductPartName: ({ commit, dispatch }, payload) => {
    commit("setActiveProductPartName", payload);
    dispatch("setShowUpload", false);
  },
  setIsLoading: ({ commit }, payload) => {
    commit("setIsLoading", payload);
  },
  setSelectedTemplateId: ({ commit }, payload) => {
    commit("setSelectedTemplateId", payload);
  },
  uploadFile: ({ commit, getters, dispatch }, payload) => {
    commit("uploadFile");
    dispatch("setPersonalizationFullPage", false);
    if (getters.getNumberOfUploads == getters.getNumberOfPP) {
      dispatch("setAddToCartFullPage", true);
    }
  },
  removeUploadedFile: ({ commit, getters, dispatch }, payload) => {
    commit("removeUploadedFile");
    if (getters.getNumberOfUploads == 0) {
      dispatch("setPersonalizationFullPage", true);
    }
    dispatch("setAddToCartFullPage", false);
  },
  uploadLoading: ({ commit }, payload) => {
    commit("uploadLoading", payload);
  },
  loadInitialData: ({ commit, getters, dispatch }, payload) => {
    if (payload.config) {
      commit("setInstanceConfig", payload.config);
    }
    commit("setWebProductId", payload.webProductId);
    commit("setWebProductSku", payload.webProductSku);
    commit("setSelectionId", payload.selectionId);

    if (
      payload.initialConfig &&
      payload.initialConfig.cimpressHiddenPageOptions
    ) {
      dispatch(
        "setCimpressHiddenPageOptions",
        payload.initialConfig.cimpressHiddenPageOptions
      );
    }

    if (payload.theme) {
      commit("setTheme", payload.theme);
    }
    if (payload.urls) {
      dispatch("setUrls", payload.urls);
    }
    if (payload.customer) {
      dispatch("setCustomer", payload.customer);
    }
    if (payload.isLogin) {
      dispatch("setIslogin", payload.isLogin);
    }
    if (payload.beforeChangeOptionsCallback) {
      dispatch(
        "setBeforeChangeOptionsCallback",
        payload.beforeChangeOptionsCallback
      );
    }
    if (payload.afterChangeOptionsCallback) {
      dispatch(
        "setAfterChangeOptionsCallback",
        payload.afterChangeOptionsCallback
      );
    }
    if (payload.afterChangePageOptionCallback) {
      dispatch(
        "setAfterChangePageOptionCallback",
        payload.afterChangePageOptionCallback
      );
    }
    if (payload.initFinalizeCallback) {
      dispatch("setInitFinalizeCallback", payload.initFinalizeCallback);
    }
    if (payload.beforePersonalizeCallback) {
      dispatch(
        "setBeforePersonalizeCallback",
        payload.beforePersonalizeCallback
      );
    }
    if (payload.photoMappingCallback) {
      dispatch("setPhotoMappingCallback", payload.photoMappingCallback);
    }

    if (payload.onCartSubmitCallback) {
      commit("registerOnCartSubmitCallback", payload.onCartSubmitCallback);
    }
    commit("setSelector", payload.selector);

    commit("setNetworkError", null);
    if (payload.isMyAccount) {
      dispatch("setCallChangeOptions", false);
      dispatch("setMyAccount", {
        isMyAccount: payload.isMyAccount,
        myAccountSelection: payload.myAccountSelection,
        myAccountUploadedFiles: payload.myAccountUploadedFiles,
        toggleReadyToConnect: payload.toggleReadyToConnect,
        myAccountUploadPath: payload.myAccountUploadPath
      });
    }

    if (payload.initialConfig) {
      if (payload.initialConfig.version) {
        commit("setDatacenterVersion", payload.initialConfig.version);
        if (payload.initialConfig.language) {
          setLanguageAttributes({
            lang: payload.initialConfig.language.lang,
            translations: payload.initialConfig.language.translations
          });
        }
        commit("setWebProductId", payload.initialConfig.webproduct_id);
        commit("setStoreCode", payload.initialConfig.store_code);
        if (!getters.getSelectionId) {
          commit("setSelectionId", getSelectionUuid(getters));
        }
        commit("setAppSelectionId", true);

        jQuery("body").addClass("printq_" + payload.initialConfig.product_type);
      }
      commit("setWebProductData", payload.initialConfig);
      afterInitialConfigData(dispatch, getters, payload.initialConfig);
      return;
    }

    var url = getters.getUrl(axios.apiGetConfig) + getters.getWebProductId;
    if (payload.getConfigTokenData) {
      // call get with Tokenized data
      url = getters.getUrl(axios.apiGet) + "?jwt=" + payload.getConfigTokenData;
    }

    if (getters.getIntegrationIdConfig) {
      var getConfigUrl = getters.getUrl(axios.apiGetConfig);
      if (getConfigUrl.charAt(getConfigUrl.length - 1) == "/") {
        getConfigUrl = getConfigUrl.slice(0, -1);
      }
      url = getConfigUrl + "?jwt=" + getters.getIntegrationIdConfig;
    }

    axios.instance
      .get(url)
      .then(response => {
        if (payload.config && payload.config.configLanguage) {
          if (response.data.data.language) {
            setLanguageAttributes({
              lang: response.data.data.language.lang,
              translations: response.data.data.language.translations
            });
          }
        }
        if (
          response.data.hasOwnProperty("success") &&
          response.data.success === 0
        ) {
          console.log(
            "Error : could not get configuration data " + response.data.message
          );
          commit("setIsLoading", false);
          commit("setNetworkError", {
            message:
              "Could not get configuration data - " + response.data.message
          });
          dispatch("callInitialLoadingFinalized", {
            type: "getData",
            status: 0
          });
          return;
        }
        var responseData = response.data;
        if (response.data.hasOwnProperty("success")) {
          // new way with Integration
          responseData = response.data.data;
          commit("setWebProductId", responseData.webproduct_id);
          commit("setStoreCode", responseData.store_code);
          commit("setDatacenterVersion", responseData.version);
          if (!getters.getSelectionId) {
            commit("setSelectionId", getSelectionUuid(getters));
          }
          commit("setAppSelectionId", true);

          jQuery("body").addClass("printq_" + responseData.product_type);
        }

        commit("setWebProductData", responseData);
        afterInitialConfigData(dispatch, getters, responseData);
      })
      .catch(error => {
        console.log("Error " + error);
        commit("setIsLoading", false);
        commit("setNetworkError", error);
        dispatch("callInitialLoadingFinalized", {
          type: "getData",
          status: 0
        });
      });
  },
  setChangeOptionsTemplate: ({ commit, getters, dispatch }, payload) => {
    var templateIds = Object.keys(getters.getActiveTemplates);
    if (templateIds.length) {
      if (!templateIds.includes(getters.getSelectedTemplateId)) {
        commit("setSelectedTemplateId", templateIds[0]);
      }
    }
  },
  setVueInstance: ({ commit }, payload) => {
    commit("setVueInstance", payload);
  },
  openFancybox: ({}, payload) => {
    const defaulOption = {
      type: "iframe",
      width: "100%",
      height: "100%",
      iframe: {
        preload: true, // false
        css: {
          width: "100%",
          height: "100%",
          "max-width": "100%",
          "max-height": "100%"
        }
      },
      opts: {
        iframe: {
          preload: true,
          css: {
            width: "100%",
            height: "100%",
            "max-width": "100%",
            "max-height": "100%"
          }
        },
        afterShow: function (instance, current) {
          toggleBodyScroll(false);
        },
        afterClose: function (instance, current) {
          toggleBodyScroll(true);
        }
      }
    };
    window.fancyboxInstance = $.fancybox.open({ ...defaulOption, ...payload });
  }
};

const toggleBodyScroll = function (status) {
  if (document.body.parentElement) {
    if (!status) document.body.parentElement.style.overflow = "hidden";
    else document.body.parentElement.style.overflow = "";
  }
};

const afterInitialConfigData = (dispatch, getters, initialData) => {
  dispatch("setCheckedPOData", getters.getWebProductData.productparts);
  window.printqMatrixConfig = getters.getWebProductData;
  window.webproductId = getters.getWebProductId;
  if (initialData && initialData.image_editor) {
    dispatch("loadImageEditorData", initialData.image_editor);
  }
  dispatch("loadCustomFromLocalStorage");
  dispatch("callInitialLoadingFinalized", {
    type: "get",
    status: 1
  });
  dispatch("changeOptions", { initialLoading: 1 });
  dispatch("setInitialUploads", getters.getProductPartsCodes);

  addDefaultTranslations(
    getters.getWebProductData.options,
    getters.getWebProductData.productparts
  );
};

const getSelectionUuid = getters => {
  if (getters.getInstanceConfig && getters.getInstanceConfig.selectionSize) {
    if (getters.getInstanceConfig.selectionSize == 32) {
      const uuid = uuidv4();
      return uuid.replaceAll("-", "");
    }
  }
  return uuidv4();
};

export default {
  state,
  getters,
  mutations,
  actions
};
